import {Component, OnDestroy, OnInit, AfterViewInit, Inject, ViewChild} from '@angular/core';
import {Store, select, ActionsSubject} from '@ngrx/store';
import * as Highcharts from 'highcharts';
import { LoadSalesStatisticListAction } from '../../actions/sales-statistic-list';
import * as fromDashboard from '../../reducers';
import {Observable, Subscription} from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { SalesStatistic } from '../../models/sales-statistic';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {LoadContentAction} from '../../actions/content-load';
import {LoadTargetAction} from '../../actions/target-load';
import {PrintPlayerComponent} from '../../../shared/components/print-player/print-player.component';
import {ModalUpdateTargetComponent} from '../../components/modal-update-target/modal-update-target.component';
import {ModalUpdateContentComponent} from '../../components/modal-update-content/modal-update-content.component';
import {OrderItem} from '../../../order/models/order-item';
import {Order} from '../../../order/models/order';
import * as fromRoot from '../../../shared/reducers';
import * as fromShared from '../../../shared/reducers';
import {Role} from '../../../shared';
import {filter, map} from 'rxjs/operators';
import {AddContractSuccessAction} from '../../../contract/actions/contract-add';
import {UpdateTargetSuccessAction} from '../../actions/target-update';
import {ModalSalesDashboardExportComponent} from '../../components/modal-sales-dashboard-export/modal-sales-dashboard-export.component';

@Component({
  selector: 'storever-dashboard-sales',
  templateUrl: './dashboard-sales.component.html',
  styleUrls: ['./dashboard-sales.component.scss']
})
export class DashboardSalesComponent implements OnDestroy, OnInit, AfterViewInit  {
  // tslint:disable-next-line:no-any
   targetItems$: Observable<any[]>;
  // tslint:disable-next-line:no-any
   contentItems$: Observable<any[]>;
   // tslint:disable-next-line
   dataNewPlayer: any[];
   // tslint:disable-next-line
   dataCumulNewPlayer: any[];
   // tslint:disable-next-line
   dataLostPlayer: any[];
   // tslint:disable-next-line
   dataCumulLostPlayer: any[];
   updateFromInput: boolean;
   highchartsRef = Highcharts;
   // tslint:disable-next-line
   chartOptionsv1: any = {
      'chart': {
         'type': 'spline'
      },
      'title': {
         'text': 'Monthly Sites Movement'
      },
      'xAxis': {
         'categories': [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
         ]
      },
      'yAxis': {
         'title': {
            'text': 'Players'
         }
      },
      'series': []
   };
   // tslint:disable-next-line
   chartOptions: any = {
      'chart': {
         'type': 'area'
      },
      'title': {
         'text': 'Monthly Cumulative new subscriptions count'
      },
      'xAxis': {
         'categories': [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
         ],
         tickmarkPlacement: 'on',
         title: {
             enabled: false
         }
      },
      'yAxis': {
         'title': {
            'text': 'Players'
         }
      },
      tooltip: {
          split: true,
          valueSuffix: ' players'
      },
      plotOptions: {
          area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                  lineWidth: 1,
                  lineColor: '#666666'
              }
          }
      },
      'series': []
   };
   subs: Subscription;
   year: string;
   // tslint:disable-next-line
   dataSum: any;
   newSum: number;
   lostSum: number;
   goalHardwareSum: number;
   goalContentSum: number;
   contentSum: number;
   hardwareSum: number;
   goalSubscriptionsSum: number;
   averagePrice: number;
  // tslint:disable-next-line:no-any
   updated: any;
   years: number[];
   // tslint:disable-next-line:no-any
   currentYear: any;
   selectedYear: number;
   roles$: Observable<Role[]>;
   private sub$: Subscription;
   private subscriptions = [];
   @ViewChild('contentModal', {static: true}) contentModal: ModalUpdateContentComponent;
   @ViewChild('targetModal', {static: true}) targetModal: ModalUpdateTargetComponent;
   @ViewChild('exportModal', {static: true}) exportModal: ModalSalesDashboardExportComponent;
  constructor(
      private store: Store<fromDashboard.AppState>,
      private storeShared: Store<fromShared.AppState>,
      private activatedRoute: ActivatedRoute,
      private translation: L10nTranslationService,
      private dispatcher: ActionsSubject,
      @Inject(L10N_LOCALE) public locale: L10nLocale) {
      this.targetItems$   = this.store.pipe(select(fromDashboard.selectors.getOrdersStatisticGoals));
      this.contentItems$  = this.store.pipe(select(fromDashboard.selectors.getOrdersStatisticRevenues));
      this.roles$ = this.storeShared.pipe(select(fromShared.selectors.getMyRoles));
      this.currentYear = new Date().getFullYear();
      this.selectedYear = this.currentYear;
      this.years = [this.currentYear - 1 , this.currentYear , this.currentYear + 1];
      const query = this.activatedRoute.snapshot.queryParams['year'];
      this.year = query ? query : new Date().getFullYear();
      this.store.dispatch(new LoadSalesStatisticListAction(this.year));
      /* tslint:disable */
      var self = this;
      this.subs = this.store.pipe(select(fromDashboard.selectors.getSalesStatistics)).subscribe(data => {
         this.dataNewPlayer = _
         .reduce(_.groupBy(data, 'office'),
            function(result, value, key) {
               (result || (result = [])).push(
                  {
                     name: key,
                     data: _.reduce(
                        _.groupBy(value, 'monthIndex'), function(result, value, key) {
                        if (!result || result.length < 12){
                           result = [0,0,0,0,0,0,0,0,0,0,0,0];
                        }
                        var currentMonth = parseInt(key) - 1;
                        result[currentMonth] = _.sumBy(value,
                           function(o){
                              return o.countNewPlayer?.length ?? 0;
                           });
                        return result;
                        }, [])
                  }
               );
               return result;
            }, []);
         this.dataCumulNewPlayer = _.map(this.dataNewPlayer, function(country){ var sum = 0; return { name: country.name, data: _.map(country.data, function(d) { return sum += d; } )}; });
         this.dataLostPlayer = _
         .reduce(_.groupBy(data, 'office'),
            function(result, value, key) {
               (result || (result = [])).push(
                  {
                     name: key,
                     data:  _.reduce(
                        _.groupBy(value, 'monthIndex'), function(result, value, key) {
                        if (!result || result.length < 12){
                           result = [0,0,0,0,0,0,0,0,0,0,0,0];
                        }
                        var currentMonth = parseInt(key) - 1;
                        result[currentMonth] = _.sumBy(value,
                           function(o){
                              return o.countLostPlayer?.length ?? 0;
                           });
                        return result;
                        }, [])
                  }
               );
               return result;
            }, []);
         this.dataCumulLostPlayer = _.map(this.dataLostPlayer, function(country){ var sum = 0; return { name: country.name, data: _.map(country.data, function(d) { return sum += d; } )}; });
         this.newSum = 0;
         this.lostSum = 0;
         this.averagePrice = 0;
         this.goalHardwareSum = 0;
         this.goalContentSum = 0;
         this.contentSum = 0;
         this.hardwareSum = 0;
         this.goalSubscriptionsSum = 0;
          this.dataSum = _
            .reduce(_.groupBy(data, 'office'),
               function(result, value, key) {
                  (result || (result = [])).push(
                     {
                        name: key,
                        new: _.sumBy(value, function(o: SalesStatistic){ return o.countNewPlayer.length; }),
                        lost: _.sumBy(value, function(o: SalesStatistic){ return o.countLostPlayer.length; }),
                        averagePrice: _.meanBy(value, function(o: SalesStatistic) { return o.averagePrice; }),
                        goalHardware: _.first(_.map(value, function(o: SalesStatistic) { return o.goalHardware; })),
                        goalContent: _.first(_.map(value, function(o: SalesStatistic) { return o.goalContent; })),
                        hardware: _.first(_.map(value, function(o: SalesStatistic) { return o.hardware; })),
                        content: _.first(_.map(value, function(o: SalesStatistic) { return o.content; })),
                        updated: _.first(_.map(value, function(o: SalesStatistic) { return o.updated; })),
                        goalSubscriptions: _.first(_.map(value, function(o: SalesStatistic) { return o.goalSubscriptions; })),
                        percentGoalSubscriptions: (
                              _.sumBy(value, function(o: SalesStatistic){ return o.countNewPlayer.length; })
                              / _.first(_.map(value, function(o: SalesStatistic) { return o.goalSubscriptions; }))
                           ) * 100
                     }
                  );
                  console.log(result);
                  self.newSum += result[result.length - 1].new;
                  self.lostSum += result[result.length - 1].lost;
                  self.averagePrice += result[result.length - 1].averagePrice;
                  self.goalHardwareSum += result[result.length - 1].goalHardware;
                  self.goalContentSum += result[result.length - 1].goalContent;
                  self.hardwareSum += result[result.length - 1].hardware;
                  self.contentSum += result[result.length - 1].content;
                  self.goalSubscriptionsSum += result[result.length - 1].goalSubscriptions;
                  self.updated = result[result.length - 1].updated;
                  return result;
               }, []);
         this.averagePrice = this.averagePrice / this.dataSum.length;
         /* tslint:enable */
         this.chartOptions.series = this.dataCumulNewPlayer;
         this.chartOptions.title.text = this.translation.translate('DASHBOARD_SALES_CHART_CUMUL_TITLE');
         // console.log('pushed chartoptions');
         // console.log(this.highchartsRef);
         // console.log(JSON.stringify(this.dataSum));
         // console.log(JSON.stringify(this.dataCumul));
         // this.highchartsRef.setOptions(this.chartOptions);
         this.updateFromInput = true;
         // this.highchartsChart.update = true;
      });
  }

   ngAfterViewInit(): void {
   }

   ngOnInit(): void {
     this.sub$ = this.dispatcher.pipe(
       filter(action => action.type === '[Target] Update Success' || action.type === '[Content] Update Success')
       // tslint:disable-next-line:no-any
     ).subscribe((data: any) => {
       this.store.dispatch(new LoadSalesStatisticListAction(this.year));
      });
   }

   ngOnDestroy(): void {
      this.subs.unsubscribe();
   }
  // tslint:disable-next-line:no-any
   getHardwareData(country: string): any {
     switch (country) {
       case 'France': return '566.018'; break;
       case 'Belgium': return '182.363'; break;
       case 'Germany': return '656.993'; break;
       case 'Spain': return '157.128'; break;
   }
}

  // tslint:disable-next-line:no-any
   getContentData(country: string): any {
    switch (country) {
      case 'France': return '42.220'; break;
      case 'Belgium': return '253.252'; break;
      case 'Germany': return '19.575'; break;
      case 'Spain': return '6.934'; break;
    }
  }
  // tslint:disable-next-line:no-any
   getGoalContentData(country: string): any {
    switch (country) {
      case 'France': return '25.125'; break;
      case 'Belgium': return '320.197'; break;
      case 'Germany': return '13.000'; break;
      case 'Spain': return '22.461'; break;
    }
  }
   showModal(type: string ): void {
    if (type === 'target') {
      this.targetModal.open();
    }
    if (type === 'exportModal') {
       this.exportModal.open();
     }
    if (type === 'content') {
      this.contentModal.open();
    }
  }
   yearChange(): void {
     this.store.dispatch(new LoadSalesStatisticListAction(this.year));
  }

   isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }

}
